// @core/api/endpoints/billing/list_billing_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListBillingPoliciesResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List billing policies
 * Returns billing policies, optionally filtered by scope entity type.
 */
export async function ListBillingPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListBillingPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/billing-policies`;
  const requestOptions = options;
  return client.get<ListBillingPoliciesResponse>(requestPath, { ...requestOptions, params });
}
